// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-src_app_config_api-endpoints_constants_ts-src_app_shared_shared_module_ts":"062f254aadcfe2a7","src_app_modules_home_home_module_ts":"7b79e86e62526040","src_app_modules_wedding_wedding_module_ts":"5bca18c2efda02f8"}[chunkId] + ".js";
};